import api from '@/lib/api';

export interface ProfessionalReview {
  id: string;
  authorName: string;
  rating: number;
  feedback: string | null;
  createdAt: string;
  reply: { text: string; repliedAt: string } | null;
}

export interface ProfessionalReviewsPagination {
  page: number;
  limit: number;
  total: number;
  hasMore: boolean;
}

export interface ProfessionalReviewsResponse {
  reviews: ProfessionalReview[];
  pagination: ProfessionalReviewsPagination;
}

export async function getProfessionalReviews(
  professionalId: string,
  page = 1,
  limit = 10
): Promise<ProfessionalReviewsResponse> {
  const response = await api.get<{ data: ProfessionalReviewsResponse }>(
    `/professionals/public/${professionalId}/reviews`,
    { params: { page, limit } }
  );
  return response.data.data;
}
